import { BElement, BaseComponent } from "utils/base-component"
import "./tab.scss"

type Config = {
  onChange: (key: string) => void
}

export class Tabs extends BaseComponent<Config> {
  static cssClass = "tabs"
  private tabs!: BElement[]

  init() {
    this.tabs = this.elements("tab")

    let activeTab = this.tabs[0]
    this.tabs.forEach((tab) => {
      if (tab.hasModifier("active")) activeTab = tab

      tab.element.addEventListener("click", (event) => {
        event.preventDefault()
        this.tabs.forEach((t) => t.toggleModifier("active", t === tab))
        this.config.onChange(tab.element.dataset.key!)
      })
    })
    this.config.onChange(activeTab.element.dataset.key!)
  }
}
